"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/es6.object.assign");
const react_1 = __importDefault(require("react"));
const gatsby_1 = require("gatsby");
const styled_components_1 = __importDefault(require("styled-components"));
const atoms_1 = require("@components/atoms");
const _utils_1 = require("@utils");
// Component
var FormResponse = function FormResponse(_ref) {
    var _contentfulAboutPage$, _contentfulAboutPage$2;
    var title = _ref.title, subhead = _ref.subhead, _ref$invert = _ref.invert, invert = _ref$invert === void 0 ? false : _ref$invert;
    var _useStaticQuery = gatsby_1.useStaticQuery(query), contentfulAboutPage = _useStaticQuery.contentfulAboutPage;
    var cdnSrc = _utils_1.imgixPath(contentfulAboutPage === null || contentfulAboutPage === void 0 ? void 0 : (_contentfulAboutPage$ = contentfulAboutPage.notFoundImage) === null || _contentfulAboutPage$ === void 0 ? void 0 : (_contentfulAboutPage$2 = _contentfulAboutPage$.file) === null || _contentfulAboutPage$2 === void 0 ? void 0 : _contentfulAboutPage$2.url); // optimization: now that <Image /> can take <source /> tags as children, we could use that below
    return /*#__PURE__*/ react_1.default.createElement(Wrapper, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.PageHeader, {
        title: title,
        subhead: subhead,
        invert: invert
    }), /*#__PURE__*/ react_1.default.createElement(atoms_1.Margin, null, /*#__PURE__*/ react_1.default.createElement(ImageWrapper, null, /*#__PURE__*/ react_1.default.createElement("picture", null, /*#__PURE__*/ react_1.default.createElement("source", {
        type: "image/webp",
        srcSet: cdnSrc + "?fm=webp"
    }), /*#__PURE__*/ react_1.default.createElement("source", {
        type: "image/jp2",
        srcSet: cdnSrc + "?fm=jp2"
    }), /*#__PURE__*/ react_1.default.createElement(StyledImage, {
        invert: invert
    })))), /*#__PURE__*/ react_1.default.createElement(atoms_1.Button, Object.assign({
        to: "/",
        lines: true,
        center: true,
        size: "large",
        type: "outline"
    }, {
        invert: invert
    }), "Discover PRIOR"));
}; // Styling
var Wrapper = styled_components_1.default.div.withConfig({
    displayName: "FormResponse__Wrapper",
    componentId: "ftn9p-0"
})([""]);
var ImageWrapper = styled_components_1.default.div.withConfig({
    displayName: "FormResponse__ImageWrapper",
    componentId: "ftn9p-1"
})(["display:flex;justify-content:center;width:100%;padding-bottom:32px;", "{padding-bottom:40px;}", "{padding-bottom:48px;}", "{padding-bottom:64px;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
/* NOTE: why aren't we using <Image /> tag?
 * Image expects everything to be retina-ready.
 * The current 404 is only 600x600.
 * If we run this through <Image /> it upsamples to like 2000x
 *
 * Would be good to modify Image to take absolute numbers someday.
 */
var StyledImage = styled_components_1.default.img.withConfig({
    displayName: "FormResponse__StyledImage",
    componentId: "ftn9p-2"
})(["display:block;width:100%;max-width:290px;max-height:290px;filter:drop-shadow(", ");", "{object-fit:contain;max-width:480px;max-height:none;height:auto;}", "{max-width:592px;}", "{max-width:680px;}"], function (props) {
    return !!props.invert ? '4px 4px 0 rgba(253, 253, 244, 1)' : '0 8px 8px rgba(0, 0, 0, 0.1)';
}, _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop')); // Typing
var query = "294373296";
exports.default = FormResponse;
